module.exports = __webpack_public_path__ + "static/media/wrong-tick.4841ccb4.png";